import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from 'axios';

// Attach the authentication header globally for all axios requests.
// The hosting page (PHP view) should set `window.VINCCO_TOKEN`.
try {
  const token = typeof window !== 'undefined' ? window.VINCCO_TOKEN : undefined;
  if (token) {
    // Use header name `Authentication` with the `Bearer` scheme as requested.
    axios.defaults.headers.common['Authentication'] = `Bearer ${token}`;
  }
} catch (err) {
  // Fail silently if window is not available or other errors occur.
  // Components can still override or supply their own headers if needed.
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
